import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { DepreciationChargesDto } from "../../../../dtos/documents/DepreciationCharges/DepreciationChargesDto";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { DepreciationChargesModel } from "../../../../models/Documents/DepreciationCharges/DepreciationChargesModel";
import { NFLookupPerson } from "../../../Shared/NewForms/NFlookupPerson";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import * as XLSX from "xlsx";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import DepreciationChargesDetailSkeleton from "./DepreciationChargesDetailSkeleton";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel } from "../../../../helpers/SaveObjectToExcel";
import { saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import { DepreciationChargesDetailFooter } from "./DepreciationChargesDetailFooter";

interface IProps {
  model: DepreciationChargesDto | null;
  modelUpdatedEvent: (newModel: DepreciationChargesDto) => void;
}

export const DepreciationChargesDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<DepreciationChargesModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const watchProducts = watch("documentDate");
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Depreciation Charges");

  useEffect(() => {
    console.log(model);
    register("documentDate");
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("companyId", model.companyId);
      setValue("personalResponsibleId", model.personalResponsibleId);
      setValue("period", model.period);
      setValue("comment", model.comment);
      setValue("createdDate", model.createdDate);
    }
  }, [model]);

  useEffect(() => {
    console.log(watchProducts);
  }, [watchProducts]);
  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: DepreciationChargesModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <DepreciationChargesDetailSkeleton />
      </>
    );
  }

  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.DepreciationCharges.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        />

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <Row>
              <Col sm={6}>
                <NFTextInput title={"Document #"} disabled fieldName={"documentNumber"} />
              </Col>
              <Col sm={6}>
                <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFDateInput title={"Period"} fieldName={"period"} required={true} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFLookupPerson title={"Personal Responsible"} fieldName={"personalResponsibleId"} />
              </Col>
              <Col sm={6}>
                <NFLookupCompany fieldName={"companyId"} title={"Company"} required={true} />
              </Col>
            </Row>
          </div>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <Row>
              <Col sm={12}>
                <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
              </Col>
              <Col sm={6}>
                <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
              </Col>
            </Row>
          </div>
        </NFTabContainer>
      </div>
      <DepreciationChargesDetailFooter/>
    </FormProvider>
  );
};
